import _ from 'lodash'

const dataFilter = (state) => {
  let data = state.categoryID === '' ? state.dataSource.ListResources : _.filter(state.dataSource.ListResources, i => i.CategoryID === state.categoryID)
  data = state.Extension === '' ? data : _.filter(data, i => i.Extension === state.Extension)
  return data
}

const dataFilterPageSize = (data, state) => {
  return data.slice((state.pageSize * state.current) - state.pageSize, state.pageSize * state.current)
}

const totalPages = (count, state) => {
  return count > state.pageSize ? Math.ceil(count / state.pageSize) : 0
}

export default {
  dataFilter,
  dataFilterPageSize,
  totalPages
}
